<template>
    <div>
        <div class="interview-header">
            Your
            <span class="font-weight-bold"
                >Green Card / U.S. residency application status</span
            >
            is:
        </div>

        <validation-observer ref="validator">
            <fly-col
                :schema="sections[0].schema"
                :data="sections[0].data"
            />
        </validation-observer>

        <modal v-model="unsupported">
            <template v-slot:title> We're Sorry </template>
            <template v-slot:body>
                Thriftax does not support tax filing for green card holders and
                U.S. residents.
                <br />
                <br />
                Since your green card application was approved, you are
                considered a U.S. resident.
                <br />
                <br />
                Made a mistake? Click "Close" and change your answer.
            </template>
        </modal>
    </div>
</template>

<script>
import baseInterviewMixin from '@/views/interview/mixins';
import { chunkyRadioPageMixin } from '@/views/interview/mixins';

export default {
    mixins: [baseInterviewMixin, chunkyRadioPageMixin],
    data() {
        return {
            pageName: 'green_card_application_status',
            unsupported: false,
        };
    },
    methods: {
        continueSubmit() {
            if (
                this.sections[0].data.green_card_application_status ===
                'Approved'
            ) {
                this.unsupported = true;
                return false;
            }
            return true;
        },
    },
};
</script>
